import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsBackward16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSkip5SecondsBackward16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.08 2.276a.55.55 0 0 1 .735 0 .453.453 0 0 1 0 .677L9.678 4h1.816a2.5 2.5 0 0 1 2.5 2.5v4a2.5 2.5 0 0 1-2.5 2.5h-2.5a.5.5 0 1 1 0-1h2.5a1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-1.5-1.5H9.678l1.137 1.047a.453.453 0 0 1 0 .677.55.55 0 0 1-.736 0L8.032 4.84a.453.453 0 0 1 0-.678zm-6.193 6.87c.68 0 1.161-.498 1.165-1.033.005-.573-.4-1.025-.887-1.025-.476 0-.822.109-1.04.21a1.6 1.6 0 0 0-.286.167l-.006.005A.5.5 0 0 1 2 7.098v-3.04h2.997a.5.5 0 1 1 0 1H3v1.214a3.6 3.6 0 0 1 1.165-.184c1.178 0 1.895 1.05 1.887 2.033-.009 1.153-1.006 2.025-2.165 2.025-.553 0-.98-.15-1.274-.307a2.2 2.2 0 0 1-.432-.301l-.028-.028-.01-.01-.004-.004-.001-.001-.001-.001.363-.344-.364.343a.5.5 0 0 1 .722-.691l.004.003.037.032c.038.03.1.074.185.12.17.09.437.189.803.189"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsBackward16);
